import React from "react";
import { Grid, Card, CardContent, Typography } from "@mui/material";
import { formatPen } from "../../../../utils/finance/format";

function KpiCard({ label, value }) {
  return (
    <Card sx={{ borderRadius: 3 }}>
      <CardContent>
        <Typography variant="body2" color="text.secondary">{label}</Typography>
        <Typography variant="h6" sx={{ mt: 1 }}>{value}</Typography>
      </CardContent>
    </Card>
  );
}

export function FinanceFiscalCards({ fiscal }) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} md={3}>
        <KpiCard label="Ventas facturadas (Total)" value={formatPen(fiscal?.sales_total)} />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <KpiCard label="Base imponible (sin IGV)" value={formatPen(fiscal?.sales_base)} />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <KpiCard label="IGV" value={formatPen(fiscal?.sales_igv)} />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <KpiCard label="N° ventas facturadas" value={String(fiscal?.sales_count ?? 0)} />
      </Grid>
    </Grid>
  );
}
